import { render, staticRenderFns } from "./MoveDepartmentModal.vue?vue&type=template&id=27465b71&scoped=true"
import script from "./MoveDepartmentModal.vue?vue&type=script&lang=js"
export * from "./MoveDepartmentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27465b71",
  null
  
)

export default component.exports